import { AxiosResponse } from 'axios'
import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { handleResponseErr } from 'utils/apiHelperUtils'
import { GetAllJobResponse, Job } from '../actions'
import * as actions from './actions'
import { DeleteJobResponse, GetJobResponse, UpdateJobResponse } from './actions'

export type actionType = 'updateJob' | 'deleteJob' | 'getAllJob' | 'getJobByID' | 'error' | ''

type InitialStateType = {
  addOrUpdatedJob?: Job
  response: UpdateJobResponse | DeleteJobResponse | GetAllJobResponse | GetJobResponse
  action: actionType
  fetching: boolean
}

const initialState: InitialStateType = {
  response: {
    data: {
      message: '',
      job: {} as Job,
    },
    statusCode: 200,
    success: false,
  },
  action: '',
  fetching: true,
}

export default function reducer(
  state = initialState,
  action: Action<AxiosResponse<UpdateJobResponse | DeleteJobResponse>>,
): InitialStateType {
  switch (action.type) {
    case actions.DELETE_JOB_BY_ID_PENDING:
    case actions.CREATE_JOB_PENDING:
    case actions.GET_ALL_JOBS_PENDING:
    case actions.GET_JOB_BY_ID_PENDING:
    case actions.UPDATE_JOB_PENDING: {
      return {
        response: {
          data: {
            message: '',
            job: {} as Job,
          },
          statusCode: 200,
          success: false,
        },
        action: '',
        fetching: true,
      }
    }

    case actions.CREATE_JOB_FULFILLED:
    case actions.DELETE_JOB_BY_ID_FULFILLED:
    case actions.UPDATE_JOB_FULFILLED: {
      const message = (action?.payload?.data as UpdateJobResponse | DeleteJobResponse)?.data.message
      Toastr.success(message)
      return {
        ...state,
        response: action?.payload?.data as UpdateJobResponse | DeleteJobResponse,
        action: action.type === 'DELETE_JOB_BY_ID_FULFILLED' ? 'deleteJob' : 'updateJob',
        fetching: false,
      }
    }

    case actions.GET_ALL_JOBS_FULFILLED: {
      return {
        ...state,
        // @ts-expect-error -- data is present
        response: action?.payload?.data,
        action: 'getAllJob',
        fetching: false,
      }
    }

    case actions.GET_JOB_BY_ID_FULFILLED: {
      return {
        ...state,
        // @ts-expect-error -- data is present
        response: action?.payload?.data,
        action: 'getJobByID',
        fetching: false,
      }
    }

    case actions.DELETE_JOB_BY_ID_REJECTED:
    case actions.GET_JOB_BY_ID_REJECTED:
    case actions.UPDATE_JOB_REJECTED:
    case actions.GET_ALL_JOBS_REJECTED:
    case actions.CREATE_JOB_REJECTED: {
      // @ts-expect-error -- its fine
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
        action: 'error',
      }
    }

    default:
      return state
  }
}
